import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";

import FieldList from "components/common/FieldList";
import Header from "components/common/Header";
import useAlert from "hooks/useAlert";
import useToken from "hooks/useToken";
import withAuth from "hocs/withAuth";
import withPermission from "hocs/withPermission";
import { IOGService } from "interfaces/ogService";
import OGServiceServices from "services/ogService";

const ServiceDetail = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { token } = useToken();
  const { onAlert } = useAlert();

  const [service, setService] = useState<IOGService | null>(null);

  useEffect(() => {
    const fetchData = () => {
      OGServiceServices.getDetail(
        token as string,
        id as string
      )
        .then((res) => {
          setService(res.data.data);
        })
        .catch((err) => {
          onAlert("error", err.response.data.message);
        });
    };

    fetchData();
  }, [id, token, onAlert]);

  if (service) {
    return (
      <>
        <Header
          title="Service Details"
          breadcrumbs={[
            {
              label: "Dashboard",
              href: `/dashboard`,
            },
            {
              label: "Only Golf",
              href: `/calendar/only-golf`,
            },
            {
              label: "Service",
              href: `/service/only-golf/list`,
            },
            {
              label: service.name,
            },
          ]}
        />
        <FieldList
          type="detail"
          fields={[
            {
              label: "Name",
              type: "text",
              name: "name",
              defaultValue: service.name,
              col: 6,
            },
            {
              label: "Duration",
              type: "number",
              name: "duration",
              defaultValue: service.duration,
              col: 6,
            },
            {
              label: "Sequence",
              type: "number",
              name: "sequence",
              defaultValue: service.sequence,
              col: 6,
            },
          ]}
          onBack={() => navigate(`/service/only-golf/list`)}
        />
      </>
    );
  } else {
    return <></>;
  }
};

export default withAuth(withPermission(ServiceDetail, "MANAGE_ONLY_GOLF"));
